import React, { useState, useEffect } from 'react'
import Typography from '@mui/material/Typography'
import { grey } from '../../../../colors'
import CustomTooltip from '../../../CustomTooltip'
import { Box } from '@mui/material'
import { ObjectListWrapper, ToolTipWrapper } from './styles'
import { Link } from 'react-router-dom'
import ROUTES from '../../../../consts/paths'

interface ObjectListProps {
  list: Array<Record<string, any>>
  disabled?: boolean
}

const ObjectList: React.FC<ObjectListProps> = ({ list = [], disabled = false }) => {
  const sortedList = [...list].sort((a, b) => a.title?.localeCompare(b.title))

  const Title = (): JSX.Element => (
    <Box display="flex" gap={1} flexWrap="wrap">
      {sortedList?.map((item: Record<string, any>, index: number) => (
       <Link to={ROUTES.INSTRUCTOR_SURVEYS} key={index}>
        <Typography fontWeight={600} color={grey[0]} fontSize="12px">
          {item?.title}
          {index !== sortedList.length - 1 && ','}
        </Typography>
       </Link>
      ))}
    </Box>
  )

  const displayedValue = sortedList[0]?.title

  return (
    <ObjectListWrapper color={grey[disabled ? 350 : 850]}>
      <Typography fontSize={'14px'}>
        {displayedValue}
      </Typography>
      {list?.length > 1 && (
        <ToolTipWrapper >
          <CustomTooltip title={<Title />}>
          <Typography mt={1.5} lineHeight={0}>...</Typography>
          </CustomTooltip>
        </ToolTipWrapper>
      )}
    </ObjectListWrapper>
  )
}

export default ObjectList
